import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/modules/shared/shared-module';
import { ConsentRecievedRoutingModule } from './consent-recieved-routing.module';
import { ConsentRecievedComponent } from './pages';


@NgModule({
  declarations: [
    ConsentRecievedComponent
   ],
  imports: [
    SharedModule,
    ConsentRecievedRoutingModule
  ]
})
export class ConsentRecievedModule { }
